import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { BarServiceService } from './bar-service.service';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { COMMON_CONSTANTS } from '../../constants/common-constants';
import { forEach } from 'lodash';
import Stock from 'highcharts/modules/stock';

Stock(Highcharts);

const CLUSTER_CONSOLIDATED_MIXED = 'IS/NA';
const CLUSTER_CONSOLIDATED_ONLY_INSUFFICIENT = 'I/S';
const CLUSTER_CONSOLIDATED_ONLY_NA = 'NA';

@Component({
  selector: 'app-vertical-group-bar-chart',
  templateUrl: './vertical-cluster-bar.component.html',
  styleUrls: ['./vertical-cluster-bar.component.scss']
})
export class Barchart18Component implements OnInit, OnDestroy {
  LowBaseSample = COMMON_CONSTANTS.LowBase_Sample;
  InsufficientBaseSample = COMMON_CONSTANTS.InsufficientBase_Sample;
  @Input() insufficientBase: string = '';
  @Input() LowBase: string = '';
  DefaultConfidenceLevel: string = '95%';
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  chart: any;
  event: any;
  datalabel: any = false;
  Highcharts: typeof Highcharts = Highcharts;
  seriesData: any = [];
  changeValue: any;
  properties: any;
  changeValueSeries: any;
  significance: any;
  changeValueSeriesUSA: any;
  significanceUSA: any;
  data: any;
  barChartData: any;
  jsonData: any;
  sampleSize: any;
  min: any;
  max: any;
  significance2: any;
   sortColumn: string = '';
  sortDirection: 'asc' | 'desc' | 'ascd' = 'ascd';
   colorDictionary:any=[];
  chartproperties = [
    {
      "showLegend": true,
      "gridlines": false,
      "shadow": false,
      "darkTheme": false,
      "legendPosition": "bottom",
      "axisLabelOrientation": "horizontal",
      "chartTitlePosition": "center",
      "showDataLabel": true,
      "datalabelStyle": "significance + changeVs",
      "axisImage": false,
      "dataLabelPosition": "center",
      "dataLabelColor": "black",
      "marker": "disable",
      "showRemaining": false,
      "gradientBarColor": false,
      "dataLabelPositionPPT": "Center",
      "datalabelFormat": "percentage",
      "markerStyle": "circle",
      "showPattern": false,
      "toolTipStyle": "default"
    }
  ]
  cleanedCategories: any[] = [];

  private splitHierarchyLevels(label: string): string[] {
    const s = String(label ?? '').trim();
    if (!s) {
      return [];
    }
    return s
      .split(/\s*:\s*/)
      .map((p) => p.trim())
      .filter((p) => p.length > 0);
  }

  private computeCommonHierarchyStripCount(labels: string[]): number {
    const normalized = labels.map((l) => String(l ?? '').trim()).filter((l) => l.length > 0);
    if (normalized.length < 2) {
      return 0;
    }
    const segmentLists = normalized.map((l) => this.splitHierarchyLevels(l));
    if (segmentLists.some((p) => p.length === 0)) {
      return 0;
    }
    const minLen = Math.min(...segmentLists.map((p) => p.length));
    let k = 0;
    while (k < minLen) {
      const seg0 = segmentLists[0][k];
      if (!segmentLists.every((parts) => parts[k] === seg0)) {
        break;
      }
      k++;
    }
    if (k === 0) {
      return 0;
    }
    const remainders = segmentLists.map((parts) => parts.slice(k));
    if (remainders.some((r) => r.length === 0)) {
      return 0;
    }
    return k;
  }

  private formatHierarchyDisplay(full: string, stripCount: number): string {
    if (stripCount <= 0) {
      return full == null ? '' : String(full);
    }
    const parts = this.splitHierarchyLevels(String(full));
    if (parts.length <= stripCount) {
      return String(full);
    }
    return parts.slice(stripCount).join(' : ');
  }

  constructor(private http: HttpClient, private barService: BarServiceService, private dataSharingService: CrosstabService) { }
  ngOnInit(): void {
    this.LowBaseSample = this.LowBase == "" ? 0 : Number(this.LowBase);
    this.InsufficientBaseSample = this.insufficientBase == "" ? 0 : Number(this.insufficientBase);

    // this.http.get<any>('../../../../../../assets/Data/barData.json').subscribe((data: any) => {
    //this.http.get<any>('assets/Data/barData_Group.json').subscribe((data: any) => {
    //  this.jsonData = data;
    //  this.data = data[0];
    //  this.barChartData = data[0]["data"];
    //  this.properties = data[0]["properties"][0];

    //  this.getBarChart('chart-container', this.seriesData, this.properties);
    //});

    this.dataSharingService.GrpChartDataSubject$.subscribe(({ data, listOfCategory, Significance, ConfidenceLevel, numberType, chartType }) => {
      this.properties = this.chartproperties[0];
      if (Significance == "None") {
        this.properties.datalabelStyle = '';
      }
      else {
        this.properties.datalabelStyle = 'change';
        this.DefaultConfidenceLevel = ConfidenceLevel;
      }
      // if (data.Data[0]['Series Name'].includes('mean')) {
      //   this.properties.datalabelFormat = '';
      // }
         if (data?.Data?.some(
      (item: any) =>
        item['Series Name']?.toString().toLowerCase().includes('mean')
    )) {
        this.properties.datalabelFormat = '';
      }
      this.jsonData = data;
      this.data = data;//data[0];
      this.barChartData = data.Data;
      this.properties = this.chartproperties[0];
      this.dataSharingService.ColorDictionarySubject$.subscribe((colors:any)=>{
      if(colors)
      {
          this.colorDictionary=colors;
      }
    });
      this.getBarChart('chart-container', this.seriesData, this.properties, chartType, listOfCategory);
    });
    this.dataSharingService.tableSorting$.subscribe(({sortColumn, sortDirection}) => {
      if (sortColumn && this.jsonData?.Data && this.jsonData.Data.length > 0) {
        this.sortColumn = sortColumn;
        this.sortDirection = sortDirection;
       
      }
    });

  }

  customization() {
    return this.barService.customizationService2();
  }

  //accessSeriesValues(seriesData: any, lowSample1: any) {
  //  const firstItem = this.jsonData[0].data[0]['Series Name'];


  //  // Find another item that is not equal to the first one based on a condition
  //  let anotherItem = this.jsonData[0].data.find((item: { [x: string]: any; }) => item['Series Name'] !== firstItem);

  //  // Extract the "Series Name" property from the found item
  //  let secondItem = anotherItem ? anotherItem['Series Name'] : 'No match found';
  //  let i = 0;
  //  const highchartsSeriesData: any = {
  //    name: firstItem,
  //    data: [],
  //    label: [],

  //    changeValue: [],
  //    pointPadding: 0.1, // Adjust this value to increase distance between bars within a cluster
  //    groupPadding: 0.2, // Keep this value to maintain distance between clusters
  //    zIndex: 2,
  //    visible: true,
  //    pointWidth: 15,
  //    color: this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
  //    // color:'red',
  //  };

  //  const highchartsSeriesDataUSA: any = {
  //    name: secondItem,
  //    data: [],
  //    label: [],
  //    pointPadding: 0.1, // Adjust this value to increase distance between bars within a cluster
  //    groupPadding: 0.2, // Keep this value to maintain distance between clusters
  //    changeValue: [],
  //    zIndex: 2,
  //    visible: true,
  //    pointWidth: 15,
  //    color: this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
  //    // color: 'yellow',
  //  };

  //  this.changeValueSeries = {
  //    name: firstItem,
  //    data: []
  //  };
  //  this.changeValueSeriesUSA = {
  //    name: secondItem,
  //    data: [],
  //  };

  //  this.significance = {
  //    name: firstItem,
  //    data: []
  //  };
  //  this.significance2 = {

  //    data: []
  //  };
  //  this.significanceUSA = {
  //    name: secondItem,
  //    data: [],
  //  };
  //  this.sampleSize = {
  //    data: [],
  //  }
  //  let valuesAddedUSA = 0;
  //  let valuesAddedIndia = 0;
  //  if (this.properties.pattern) {
  //    highchartsSeriesData.color = 'url(#pattern3)';
  //    highchartsSeriesDataUSA.color = 'url(#pattern2)';
  //  }
  //  for (const series of this.barChartData) {
  //    const value = parseFloat(series['Rounded Value']) == 0 || parseFloat(series['Rounded Value']) == null ? 0 : parseFloat(series['Rounded Value']);
  //    const numericValue = !lowSample1 ? value : (parseFloat(series['Sample size']) > 9000 ? value : 0);
  //    const label = parseFloat(series.Label);
  //    const change = parseFloat(series["Change value vs PY"]);
  //    const sample = parseFloat(series["Sample size"]);
  //    const significance1 = parseFloat(series["Significance"]);
  //    const significance2 = parseFloat(series["Significance2"]);
  //    if (series["Series Name"] === firstItem && valuesAddedIndia < 5) {

  //      highchartsSeriesData.data.push(numericValue);
  //      highchartsSeriesData.label.push(label);
  //      highchartsSeriesData.changeValue.push(change);

  //      valuesAddedIndia++;
  //    }
  //    else if (series["Series Name"] === secondItem && valuesAddedUSA < 5) {
  //      highchartsSeriesDataUSA.data.push(numericValue);
  //      highchartsSeriesDataUSA.label.push(label);
  //      highchartsSeriesDataUSA.changeValue.push(change);

  //      valuesAddedUSA++;

  //    }
  //    this.sampleSize.data.push(sample);
  //    this.significance2.data.push(significance2)
  //    this.significance.data.push(significance1);
  //    this.changeValueSeries.data.push(change);
  //  }
  //  let allData = [...highchartsSeriesData.data, ...highchartsSeriesDataUSA.data];

  //  let maxValue = Math.max(...allData)
  //  let minValue = Math.min(...allData);
  //  this.max = maxValue + Math.ceil(maxValue * 0.2);
  //  this.min = minValue + Math.ceil(minValue * 0.2);
  //  this.seriesData = [highchartsSeriesData, highchartsSeriesDataUSA];
  //}
  // set the bar width based on series count for horizontal group chart
  
  accessSeriesValues(seriesData: any, lowSample1: any, listOfCategory: any, chartType: any) {
     this.dataSharingService.tableSorting$.subscribe(({sortColumn, sortDirection}) => {     
      if (sortColumn && this.jsonData?.Data && this.jsonData.Data.length > 0) {      
        this.sortColumn = sortColumn;
        this.sortDirection = sortDirection;
       
      }
    });
  const seriesNames: string[] = Array.from(new Set(this.jsonData.Data.map((item: any) => item['Series Name'])));
  let IB = this.InsufficientBaseSample;
  let i = 0;

  const highchartsSeriesData: any[] = [];

  // Determine the series order from sortColumn if it exists
  let seriesOrder: string[] = [];
  if (this.sortColumn) {
    const sortColumnData = this.barChartData.filter(
      (a: any) => this.cleanText(a["Category Name"]) === this.cleanText(this.sortColumn)
    );
    const uniqueKeys = ["Category Name", "Series Name"];
    let uniqueSortData = this.getUnique(sortColumnData, uniqueKeys);
    uniqueSortData = this.sortSeriesDataByDataArray(uniqueSortData, this.sortDirection);
    seriesOrder = uniqueSortData.map(series => series["Series Name"] || series.name);
  }

  // Sort seriesNames to match the series order from sortColumn
  let orderedSeriesNames = [...seriesNames];
  if (seriesOrder.length > 0) {
    orderedSeriesNames.sort((a, b) => {
      const aIndex = seriesOrder.indexOf(a);
      const bIndex = seriesOrder.indexOf(b);
      
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      return 0;
    });
  }

  const seriesHierarchyK = this.computeCommonHierarchyStripCount(orderedSeriesNames);

  for (const seriesName of orderedSeriesNames) {
    /* const data = this.barChartData.filter((a: any) => a["Category Name"] == catName);*/
    const currentSeriesData: any = {
      name: seriesName,
      displayName: this.formatHierarchyDisplay(seriesName, seriesHierarchyK),
      data: [],
      label: [],
      changeValue: [],
      Significance: [],
      samplesize: [],
      invalidClusterCause: [],
      /*  pointPadding: 0.1,*/
      groupPadding: 0.2,
      zIndex: 2,
      visible: true,

      // pointWidth: this.getValueforBarsize(chartType,seriesNames),

      color: this.barService.color1[i],

    };

    if (this.properties.pattern) {
      currentSeriesData.color = `url(#pattern${i})`;
    }
    
    for (const catName of listOfCategory) {
      const data = this.barChartData.filter((a: any) => a["Category Name"] == catName);

      const uniqueKeys = ["Category Name", "Series Name"];
      let uniqueData = this.getUnique(data, uniqueKeys);
      
      // Sort uniqueData to match series order if not the sortColumn
      if (seriesOrder.length > 0 && this.cleanText(catName) !== this.cleanText(this.sortColumn)) {
        uniqueData.sort((a, b) => {
          const aName = a["Series Name"] || a.name;
          const bName = b["Series Name"] || b.name;
          const aIndex = seriesOrder.indexOf(aName);
          const bIndex = seriesOrder.indexOf(bName);
          
          if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
          }
          if (aIndex !== -1) return -1;
          if (bIndex !== -1) return 1;
          return 0;
        });
      } else if (this.cleanText(catName) === this.cleanText(this.sortColumn)) {
        uniqueData = this.sortSeriesDataByDataArray(uniqueData, this.sortDirection);
      }
      
      const row = uniqueData.find((s: any) => s["Series Name"] === seriesName);
      if (row) {
        const sample = parseFloat(row["Sample size"]);
        let value = parseFloat(row['Rounded Value']);
        let invalidClusterCause: 'na' | 'is' | null = null;
        if (row['Rounded Value'] === 'NA' || row['Rounded Value'] == 'NA' || isNaN(value)) {
          value = 0.000001;
          invalidClusterCause = 'na';
        } else if (sample != 0 && !isNaN(sample) && sample < IB) {
          value = 0.000001;
          invalidClusterCause = 'is';
        } else if (value === 0) {
          value = 0;
        } else {
          value = value || 0.000001;
          if (value === 0.000001) {
            invalidClusterCause = 'na';
          }
        }

        const numericValue = value;
        currentSeriesData.data.push(numericValue);

        let label = parseFloat(row.Label);
        currentSeriesData.label.push(label);

        let changeValue = parseFloat(row["Change value vs PY"]);
        currentSeriesData.changeValue.push(changeValue);

        currentSeriesData.Significance.push(parseFloat(row["Significance"]));
        currentSeriesData.samplesize.push(parseFloat(row["Sample size"]));
        currentSeriesData.invalidClusterCause.push(invalidClusterCause);
      } else {
        currentSeriesData.data.push(0.000001);
        currentSeriesData.label.push(NaN);
        currentSeriesData.changeValue.push(NaN);
        currentSeriesData.Significance.push(NaN);
        currentSeriesData.samplesize.push(0);
        currentSeriesData.invalidClusterCause.push('na');
      }
      // }
    }
    highchartsSeriesData.push(currentSeriesData);

    i++; // Increment i for the next iteration

  }
  if(this.colorDictionary.length==0)
  {
    let ColorDictionary:any=[];
       highchartsSeriesData.forEach((series, index) => {
        ColorDictionary.push({name:series.name.replace(/\s+/g, ""),color:series.color})
      });
      this.dataSharingService.setColorDictionary(ColorDictionary);
  }else{
       highchartsSeriesData.forEach((series, index) => {
             let customcolor =  this.colorDictionary.find((x: any)=>x.name==series.name.replace(/\s+/g, ""));
        series.color = customcolor.color;
      
      });
    }

  const allData = highchartsSeriesData.flatMap(series => series.data);
  const maxValue = Math.max(...allData);
  const minValue = Math.min(...allData);

  this.max = maxValue + Math.ceil(maxValue * 0.2);
  this.min = 0;// minValue + Math.ceil(minValue * 0.2);
  this.seriesData = highchartsSeriesData;
}
  private static readonly INVALID_CLUSTER_VALUE = 0.000001;

  private clusterBarYIsInvalidSentinel(y: any): boolean {
    if (y === null || y === undefined) {
      return false;
    }
    const S = Barchart18Component.INVALID_CLUSTER_VALUE;
    if (y === S) {
      return true;
    }
    return typeof y === 'number' && !isNaN(y) && Math.abs(y - S) < 1e-9;
  }

  private clusterBarPointIsInvalidForConsolidation(s: any, j: number, insufficientBase: number): boolean {
    const ss = Number(s.samplesize[j]);
    if (ss !== 0 && !isNaN(ss) && insufficientBase > 0 && ss < insufficientBase) {
      return true;
    }
    return this.clusterBarYIsInvalidSentinel(s.data[j]);
  }

  private prepareClusterConsolidatedNaIs(
    chartType: string,
    insufficientBase: number
  ): { scatterSeries: any | null; consolidatedIndices: Set<number> } {
    const consolidatedIndices = new Set<number>();
    const seriesData = this.seriesData;
    if (!seriesData?.length) {
      return { scatterSeries: null, consolidatedIndices };
    }
    const numCats = seriesData[0].data?.length ?? 0;
    if (numCats < 1) {
      return { scatterSeries: null, consolidatedIndices };
    }
    const isBar = chartType === 'bar';
    const points: any[] = [];

    for (let j = 0; j < numCats; j++) {
      const allInvalid = seriesData.every((s: any) =>
        this.clusterBarPointIsInvalidForConsolidation(s, j, insufficientBase)
      );
      if (!allInvalid) {
        continue;
      }
      consolidatedIndices.add(j);
      const insufficientAt = (s: any) => {
        const c = s.invalidClusterCause?.[j];
        if (c === 'is') {
          return true;
        }
        if (c === 'na') {
          return false;
        }
        const ss = Number(s.samplesize[j]);
        return (
          ss !== 0 && !isNaN(ss) && insufficientBase > 0 && ss < insufficientBase
        );
      };
      const naStyleOnlyAt = (s: any) => {
        const c = s.invalidClusterCause?.[j];
        if (c === 'na') {
          return true;
        }
        if (c === 'is') {
          return false;
        }
        const ss = Number(s.samplesize[j]);
        const insufficient =
          ss !== 0 && !isNaN(ss) && insufficientBase > 0 && ss < insufficientBase;
        return !insufficient && this.clusterBarYIsInvalidSentinel(s.data[j]);
      };
      const allInsufficientOnly = seriesData.every(insufficientAt);
      const allNaOnly = seriesData.every(naStyleOnlyAt);
      const text: string = allInsufficientOnly
        ? CLUSTER_CONSOLIDATED_ONLY_INSUFFICIENT
        : allNaOnly
          ? CLUSTER_CONSOLIDATED_ONLY_NA
          : CLUSTER_CONSOLIDATED_MIXED;
      for (const s of seriesData) {
        s.data[j] = null;
      }
      if (isBar) {
        points.push({
          x: 0,
          y: j,
          marker: { enabled: false, radius: 0 },
          custom: { consolidatedText: text }
        });
      } else {
        points.push({
          x: j,
          y: 0,
          marker: { enabled: false, radius: 0 },
          custom: { consolidatedText: text }
        });
      }
    }

    if (!points.length) {
      return { scatterSeries: null, consolidatedIndices };
    }

    const showDL = this.properties.showDataLabel !== false;
    const textColor = this.properties.darkTheme ? 'white' : 'black';

    const scatterSeries = {
      type: 'scatter',
      name: '__consolidatedNaIs',
      showInLegend: false,
      enableMouseTracking: false,
      clip: false,
      data: points,
      dataLabels: {
        enabled: showDL,
        useHTML: true,
        allowOverlap: true,
        crop: false,
        overflow: 'allow' as any,
        ...(isBar
          ? { align: 'left' as any, verticalAlign: 'middle' as any, x: 8 }
          : { align: 'center' as any, verticalAlign: 'bottom' as any, y: -4 }),
        formatter: function (this: any) {
          const t = this.point?.custom?.consolidatedText;
          return t
            ? "<div style='font-size: 0.7rem;text-align: center;color:" + textColor + "'>" + t + '</div>'
            : '';
        }
      }
    };
    return { scatterSeries, consolidatedIndices };
  }

  getValueforBarsize(chartType: any, seriesNames: any) {
    if (chartType == "bar") {
      if (seriesNames.length > 6) {
        return 8;
      }
      else {
        return 15;
      }
    }
    return 15;
  }
  getSigLowerLimit() {
    return this.DefaultConfidenceLevel == '95%'
      ? COMMON_CONSTANTS.SigLowerLimit_95
      : this.DefaultConfidenceLevel == '90%'
        ? COMMON_CONSTANTS.SigLowerLimit_90
        : this.DefaultConfidenceLevel == '98%'
          ? COMMON_CONSTANTS.SigLowerLimit_98
          : COMMON_CONSTANTS.SigLowerLimit_95;
  }
  getSigUpperLimit() {
    return this.DefaultConfidenceLevel == '95%'
      ? COMMON_CONSTANTS.SigUpperLimit_95
      : this.DefaultConfidenceLevel == '90%'
        ? COMMON_CONSTANTS.SigUpperLimit_90
        : this.DefaultConfidenceLevel == '98%'
          ? COMMON_CONSTANTS.SigUpperLimit_98
          : COMMON_CONSTANTS.SigUpperLimit_95;
  }
  patternselect(ispattern: boolean) {
    this.properties.pattern = ispattern
    this.accessSeriesValues(this.jsonData, this.properties.datalabelStyle == "ls", "", "");
    this.getBarChart('chart-container', this.seriesData, this.properties, "", "");
    ;
  }
  commonfunc(event: any, customization: string, options: any) {
    this.event = event;
    this.properties = this.barService.commonFunc(customization, event, this.properties)
    //this.accessSeriesValues(this.properties.lowSample);
    this.getBarChart('chart-container', this.seriesData, this.properties, "", "");
  }
  getBarChart(containerid: string, seriesData: any, properties: any, chartType: string, listOfCategory: any) {
    localStorage.setItem("properties", JSON.stringify(this.properties));
    this.accessSeriesValues(this.seriesData, this.properties.datalabelStyle == "ls", listOfCategory, chartType);
    let serviceBar = this.barService;
    const plot = this.barService.plot2;
    //let change = this.changeValueSeries.data;
    //let signi = this.significance.data;
    //let signi2 = this.significance2.data;
    let c = 0;
    // let samplesize = this.sampleSize.data;
    const updatedCategories = this.barService.updatedCategories;
    const plotDark = this.barService.plot2Dark;
  const defaultCategories = listOfCategory;
  const categoryHierarchyK = this.computeCommonHierarchyStripCount(
    (listOfCategory || []).map((c: any) => String(c))
  );
  this.cleanedCategories = (defaultCategories || []).map((c: any) =>
    this.formatHierarchyDisplay(String(c), categoryHierarchyK)
  );
    // scroll enable and maximum category show in screen based on condition
    //const maxCatrgories = chartType == "bar" ? this.seriesData.length > 6 ? 1 : listOfCategory.length - 1 : listOfCategory.length > 5 ? 4 : listOfCategory.length - 1;
    //const isScrollEnabled = chartType == "bar" ? this.seriesData.length > 6 ? true : listOfCategory.length > 5 ? true : false : listOfCategory.length > 5 ? true : false;

    const maxCatrgories = chartType == "bar" ? (this.seriesData.length >= 6 && listOfCategory.length >= 3) ? 1 : (this.seriesData.length >= 3 && listOfCategory.length >= 3) ? 1 : (listOfCategory.length > 5 ? 4 : listOfCategory.length - 1) : (listOfCategory.length > 5 ? 4 : listOfCategory.length - 1);
    const isScrollEnabled = chartType == "bar" ? (this.seriesData.length >= 6 && listOfCategory.length >= 3) ? true : (this.seriesData.length >= 3 && listOfCategory.length >= 3) ? true : (listOfCategory.length > 5 ? true : false) : (listOfCategory.length > 5 ? true : false);
    const { scatterSeries: consolidatedScatterSeries, consolidatedIndices } = this.prepareClusterConsolidatedNaIs(
      chartType === 'bar' ? 'bar' : 'column',
      this.InsufficientBaseSample
    );
    const hideClusterDataLabelAt: Record<number, boolean> = {};
    consolidatedIndices.forEach((j) => {
      hideClusterDataLabelAt[j] = true;
    });
 let sigLowerValue = this.getSigLowerLimit();
    let sigUpperValue = this.getSigUpperLimit();
    let InsufficientBase = this.InsufficientBaseSample;
    let lowSample = this.LowBaseSample;
    const containerEl = document.getElementById(containerid);
    if (!containerEl) { return; }
    this.chart = Highcharts.chart(containerEl, {
      chart: {
        type: chartType,
        backgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
        style: {
          color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          fontFamily:"KantarBrown-Regular"
        },
      },
      title: {
        text: '',//this.data.title,
        align: this.properties.chartTitlePosition,
        style: {
          color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
        },
      },
      subtitle: {

        align: 'left',
        style: {
          color: 'grey',
        },
      },
      exporting: {
        enabled: false,
      },
      legend: {
        ...this.barService.customizeLegend(this.chart, this.properties.showLegend, this.properties.legendPosition, this.properties),
        labelFormatter: function (this: any) {
          const uo = this.userOptions || {};
          return uo.displayName != null && uo.displayName !== ''
            ? uo.displayName
            : this.name;
        },
      },
      xAxis: {

        categories: this.cleanedCategories,
        min: 0,
        max: maxCatrgories,
        scrollbar: {
          enabled: isScrollEnabled,
          height: 6, // Adjust the height of the scrollbar as needed
          barBackgroundColor: '#999',
          barBorderRadius: 3,
          barBorderWidth: 0,
          //barBorderColor: '#c9c9c9',
          buttonBackgroundColor: 'transparent',
          buttonBorderWidth: 0,
          buttonArrowColor: '#aaa',
          //buttonBorderRadius: 0,
          rifleColor: 'transparent',
          trackBackgroundColor: '#f5f5f5',
          trackBorderWidth: 0,
          //trackBorderColor: 'black',
          trackBorderRadius: 3
        },
        plotBands: this.properties.darkTheme ? plotDark : plot,
        accessibility: {
          description: 'Countries'
        },
        labels: {
          //useHTML: true,
          //style: {
          //  color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          //},
          //formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
          //  if (properties.axisImage) {
          //    const index = defaultCategories.indexOf(String(this.value));
          //    const category = updatedCategories[index];

          //    if (category && category.image) {
          //      return '<span style="display: inline-block; width: 20px; height: 20px; background: url(' + category.image + ') no-repeat center center; background-size: cover;"></span>';
          //    } else {
          //      return '<span>No Image</span>';
          //    }
          //  } else {
          //    return String(this.value);
          //  }
          //},

          rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
        }
      },
      yAxis: {
        scrollbar: {
          enabled: true,
          showFull: false, // Set to false if you want to see only part of the scrollbar initially
        },
        visible: this.properties.gridlines,
        max: this.max,
        min: this.min,
        margin: 1,
        tickInterval: 20, // Set the interval between ticks to 10 units
        accessibility: {
          rangeDescription: 'Range: 0 to 100' // Update the accessibility range description
        },
        labels: {
          style: {
            color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          },
        },
        title: {
          text: '', // Set an empty string to hide the yAxis title
        },
      },
      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        shape: properties.toolTipStyle == "style1" ? 'rect' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',

        formatter: function (this: any) {
          if (this.series.name === 'Marker1') return false;
          if (this.series.name === '__consolidatedNaIs') return false;
          const dotColor = this.series.color;
          let content =
            `<div style="background-color: #f5f5f5; padding: 5px; align-items: center; border: 1px solid ${dotColor};border-radius:2px; ">` +
            ` ${(this.series.userOptions && this.series.userOptions.displayName) ? this.series.userOptions.displayName : this.series.name}` +
            `<div style="display: block; margin-top: 5px;"><strong>Value:</strong>` +
            ` ${this.point.series.userOptions.samplesize[this.point.x] != 0 && this.point.series.userOptions.samplesize[this.point.x] < InsufficientBase ? 'I/S' :
              this.point.y == 0.000001 ? 'NA' :
                (this.point.series.userOptions.samplesize[this.point.x] != 0 && (this.point.series.userOptions.samplesize[this.point.x] < lowSample && this.series.userOptions.samplesize[this.point.x] > InsufficientBase)) ?
                  (this.point.y + (properties.datalabelFormat == "percentage" ? '%' : '') + ('*')) :
                  (this.point.y + (properties.datalabelFormat == "percentage" ? '%' : ''))}` +
            `</div>`;

          if (properties.datalabelStyle == 'change') {
            // Use precomputed significance thresholds from outer closure
            const lower = sigLowerValue;
            const upper = sigUpperValue;
            const changeRaw = this.series.userOptions.changeValue[this.point.x];
            let changeDisp = isNaN(changeRaw) ? 'NA' : (changeRaw + (properties.datalabelFormat == 'percentage' ? '%' : ''));
            const sig = this.series.userOptions.Significance[this.point.x];
            let color = 'black';
            if (changeDisp !== 'NA' && !isNaN(sig)) {
              if (sig < lower) {
                color = 'red';
              } else if (sig > upper) {
                color = 'green';
              }
            }
            content += `<div style="display:flex;align-items:center;margin-top:2px;"><strong style="margin-right:4px;">Change:</strong><span style="color:${color};font-weight:bold;">${changeDisp}</span></div>`;
          }

          return content + '</div>';
        },
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        column: {

          stacking: undefined,
          shadow: this.properties.shadow ? {
            color: this.barService.shadowColor,
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          //pointWidth: 15,

          dataLabels:

          {
            style: {

              backgroundColor: this.barService.transparentBackground,

              textOutline: 'none',

              color: 'black',

            },
            enabled: true,
            inside: false,
            align: this.properties.datalabelOrientation == 90 && this.properties.dataLabelPosition == 'center' ? 'left' : this.properties.dataLabelPosition,
            padding: 9,
            rotation: this.properties.datalabelOrientation,

       
formatter: function (this: any) {
  if (this.series.name === '__consolidatedNaIs') {
    return '';
  }
  if (hideClusterDataLabelAt[this.point.x]) {
    return '';
  }
  if (this.y === null || this.y === undefined) {
    return '';
  }
  if (properties.datalabelStyle == "change") {
    this.Sig_LowerLimt = sigLowerValue;
    this.Sig_UpperLimt = sigUpperValue;

    const sampleSize = this.series.userOptions.samplesize[this.point.x];
    let text = (sampleSize != 0 && sampleSize < InsufficientBase)
      ? 'I/S'
      : (this.y == 0.000001 ? 'NA' : (this.y + (properties.datalabelFormat == "percentage" ? '%' : '')));
    let changevspy = isNaN(this.series.userOptions.changeValue[this.point.x])
      ? "(NA)"
      : '(' + this.series.userOptions.changeValue[this.point.x] + (properties.datalabelFormat == "percentage" ? '%' : '') + ')';
    let sig = this.series.userOptions.Significance[this.point.x];

    // Helper for line break based on chart type
    const lineBreak = this.series.chart.options.chart.type === 'column' ? '<br>' : '';

    if (text == 'I/S' || text == 'NA') {
      return `<span>${text}</span>`;
    }
    if (changevspy == '(NA)') {
      return `<span>${text}${lineBreak}<span style="font-size:0.7em;">${changevspy}</span></span>`;
    }
    if (sig < this.Sig_LowerLimt) {
      return `<span>${text}${lineBreak}<span style="color: red;font-size:0.7em;">${changevspy}</span></span>`;
    }
    if (sig > this.Sig_UpperLimt) {
      return `<span>${text}${lineBreak}<span style="color: green;font-size:0.7em;">${changevspy}</span></span>`;
    }
    return `<span>${text}${lineBreak}<span style="font-size:0.7em;">${changevspy}</span></span>`;
  }

 
  return (
    (this.series.userOptions.samplesize[this.point.x] != 0 && this.series.userOptions.samplesize[this.point.x] < InsufficientBase)
      ? 'I/S'
      : this.y == 0.000001
        ? 'NA'
        : (this.series.userOptions.samplesize[this.point.x] != 0 &&
          (this.series.userOptions.samplesize[this.point.x] < lowSample &&
            this.series.userOptions.samplesize[this.point.x] > InsufficientBase))
          ? (this.y + (properties.datalabelFormat == "percentage" ? '%' : '') + ('*'))
          : (this.y + (properties.datalabelFormat == "percentage" ? '%' : ''))
  );
},


          },
          states: {
            hover: {
              enabled: true,
              color: undefined, // disable color override
              brightness: 0     // disable lightening
            }
          }
        },
        bar: {
          stacking: undefined,
          shadow: this.properties.shadow ? {
            color: this.barService.shadowColor,
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          //pointWidth: 15,

          dataLabels:

          {
            style: {

              backgroundColor: this.barService.transparentBackground,

              textOutline: 'none',

              color: 'black',

            },
            enabled: true,
            inside: false,
            align: 'left',
            padding: 9,
            rotation: this.properties.datalabelOrientation,

          formatter: function (this: any) {
  if (this.series.name === '__consolidatedNaIs') {
    return '';
  }
  if (hideClusterDataLabelAt[this.point.x]) {
    return '';
  }
  if (this.y === null || this.y === undefined) {
    return '';
  }
  if (properties.datalabelStyle == "change") {
    this.Sig_LowerLimt = sigLowerValue;
    this.Sig_UpperLimt = sigUpperValue;

    const sampleSize = this.series.userOptions.samplesize[this.point.x];
    let text = (sampleSize != 0 && sampleSize < InsufficientBase)
      ? 'I/S'
      : (this.y == 0.000001 ? 'NA' : (this.y + (properties.datalabelFormat == "percentage" ? '%' : '')));
    let changevspy = isNaN(this.series.userOptions.changeValue[this.point.x])
      ? "(NA)"
      : '(' + this.series.userOptions.changeValue[this.point.x] + (properties.datalabelFormat == "percentage" ? '%' : '') + ')';
    let sig = this.series.userOptions.Significance[this.point.x];

    // Only add <br> for column chart type
    const lineBreak = this.series.chart.options.chart.type === 'column' ? '<br>' : '';

    if (text == 'I/S' || text == 'NA') {
      return `<span>${text}</span>`;
    }
    if (changevspy == '(NA)') {
      return `<span>${text}${lineBreak}<span style="font-size:0.7em;">${changevspy}</span></span>`;
    }
    if (sig < this.Sig_LowerLimt) {
      return `<span>${text}${lineBreak}<span style="color: red;font-size:0.7em;">${changevspy}</span></span>`;
    }
    if (sig > this.Sig_UpperLimt) {
      return `<span>${text}${lineBreak}<span style="color: green;font-size:0.7em;">${changevspy}</span></span>`;
    }
    return `<span>${text}${lineBreak}<span>${changevspy}</span></span>`;
  }
  return (
    (this.series.userOptions.samplesize[this.point.x] != 0 && this.series.userOptions.samplesize[this.point.x] < InsufficientBase)
      ? 'I/S'
      : this.y == 0.000001
        ? 'NA'
        : (this.series.userOptions.samplesize[this.point.x] != 0 &&
          (this.series.userOptions.samplesize[this.point.x] < lowSample &&
            this.series.userOptions.samplesize[this.point.x] > InsufficientBase))
          ? (this.y + (properties.datalabelFormat == "percentage" ? '%' : '') + ('*'))
          : (this.y + (properties.datalabelFormat == "percentage" ? '%' : ''))
  );
},

          }
        },
        scatter: {
          states: {
            hover: { enabled: false },
            inactive: { enabled: false }
          }
        }
      },
      series: consolidatedScatterSeries
        ? [...this.seriesData, consolidatedScatterSeries]
        : this.seriesData,
    });

  }
  userselectedproperties() {
    this.data["properties"][0] = this.properties;
    return JSON.stringify(this.data).toString();
  }
  getUnique(arr: any[], keys: string[]): any[] {
    const map = new Map<string, any>();
    arr.forEach(item => {
      const compositeKey = keys.map(key => item[key]).join('|');
      if (!map.has(compositeKey)) {
        map.set(compositeKey, item);
      }
    });
    return Array.from(map.values());
  }
  sortSeriesDataByDataArray(
  seriesData: any[],
  direction: 'asc' | 'desc' | 'ascd' = 'ascd'
): any[] {

  // If ascd → return original array without sorting
  if (direction === 'ascd') {
    return seriesData;
  }

  return [...seriesData].sort((a, b) => {
    const valA = Number(a.Value) || 0;
    const valB = Number(b.Value) || 0;

    return direction === 'desc' ? valB - valA : valA - valB;
  });
}
   cleanText(str: string): string {
        if (!str) return '';

        return str
          .replace(/[|:]/g, '')  
          .replace(/\s+/g, '')   
          .trim()
          .toLowerCase();     
      }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null as any;
    }
  }
}
